import { render, staticRenderFns } from "./CharterSchools.vue?vue&type=template&id=0dad75e2&scoped=true&"
import script from "./CharterSchools.vue?vue&type=script&lang=js&"
export * from "./CharterSchools.vue?vue&type=script&lang=js&"
import style0 from "./CharterSchools.vue?vue&type=style&index=0&id=0dad75e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dad75e2",
  null
  
)

export default component.exports